import { render, staticRenderFns } from "./projectApprovalRequests.vue?vue&type=template&id=015b176a"
import script from "./projectApprovalRequests.vue?vue&type=script&lang=js"
export * from "./projectApprovalRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports